import { BaseDateCalculateExpression, DateSpanType } from "./BaseDateCalculateExpression";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { add, addBusinessDays } from "date-fns";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class DateAddXExpression extends BaseDateCalculateExpression {
    readonly __type: string = "Add to Date";

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        let d = this.baseDate.evaluate(data, testContext) as Date;
        let adjustBy = this.adjustBy.evaluate(data, testContext) as number;

        switch (this.calculateType) {
            case DateSpanType.SECONDS:
                return add(d, { seconds: adjustBy });
            case DateSpanType.MINUTES:
                return add(d, { minutes: adjustBy });
            case DateSpanType.DAYS:
                return add(d, { days: adjustBy });
            case DateSpanType.BUSINESS_DAYS:
                return addBusinessDays(d, adjustBy);
            case DateSpanType.WEEKS:
                return add(d, { weeks: adjustBy });
            case DateSpanType.MONTHS:
                return add(d, { months: adjustBy });
            case DateSpanType.YEARS:
                return add(d, { years: adjustBy });
        }
    }
}
